export default "__VITE_ASSET__DuHyn9jY__"